import { generateAutomationName } from "../../helpers/generateAutomationName";

export const headerDataAutomation = {
    wrapper: generateAutomationName("home", ["header", "wrapper"]),
    sharedByIcon: generateAutomationName("project", ["header", "sharedBy", "icon"]),
    countryIcon: generateAutomationName("project", ["header", "country", "icon"]),
    settingsButton: generateAutomationName("project", ["header", "settings", "button"]),
    loader: generateAutomationName("project", ["header", "loader"]),
    breadcrumbs: generateAutomationName("project", ["header", "breadcrumbs"]),
    dropdownButton: generateAutomationName("project", ["header", "dropdown", "button"]),
};
